import {Card, Icon, DeprecatedCreativeModal as Modal} from '@forecast-it/design-system';
import React from 'react';
import {useIntl} from 'react-intl';
import {createFragmentContainer, graphql} from 'react-relay';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {REPORT_TYPE, ReportType} from '../../../../../constants';
import {PERMISSION_TYPE} from '../../../../../Permissions';
import {hasSomePermission} from '../../../../shared/util/PermissionsUtil';

const GridContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 24px;
`;

const CreateReportModal = ({createReport, viewer, closeModal}) => {
	const {company} = viewer;
	const history = useHistory();
	const {formatMessage} = useIntl();

	const hasFinancialAccess = hasSomePermission([
		PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION,
		PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE,
	]);

	function handleCreateReport(type: ReportType) {
		return createReport(type, company, history, closeModal);
	}

	return (
		<Modal title="Create a New Report" size="xl" withoutButtons closeModal={closeModal} replicateDesignSystem>
			<GridContainer>
				<Card data-cy={'create-report-card-time-reg'} onClick={() => handleCreateReport(REPORT_TYPE.TIME_REG)}>
					<Card.Title>
						<Icon icon={'clock'} />
						{formatMessage({id: 'report.time_registration.title'})}
					</Card.Title>
					<Card.Body>{formatMessage({id: 'report.time_registration.description'})}</Card.Body>
				</Card>
				{hasFinancialAccess ? (
					<Card
						data-cy={'create-report-card-ppr'}
						onClick={() => handleCreateReport(REPORT_TYPE.PROJECT_PORTFOLIO_REPORT)}
					>
						<Card.Title>
							<Icon icon={'briefcase'} />
							{formatMessage({id: 'report.project_portfolio.title'})}
						</Card.Title>
						<Card.Body>{formatMessage({id: 'report.project_portfolio.description'})}</Card.Body>
					</Card>
				) : null}
				<Card data-cy={'create-report-card-ut'} onClick={() => handleCreateReport(REPORT_TYPE.UTILIZATION_REPORT)}>
					<Card.Title>
						<Icon icon={'gauge'} />
						{formatMessage({id: 'report.utilization.title'})}
					</Card.Title>
					<Card.Body>{formatMessage({id: 'report.utilization.description'})}</Card.Body>
				</Card>
				<Card data-cy={'create-report-card-task'} onClick={() => handleCreateReport(REPORT_TYPE.TASK_REPORT)}>
					<Card.Title>
						<Icon icon={'task'} />
						{formatMessage({id: 'report.task.title'})}
					</Card.Title>
					<Card.Body>{formatMessage({id: 'report.task.description'})}</Card.Body>
				</Card>
			</GridContainer>
		</Modal>
	);
};

export const CreateReportModalQuery = graphql`
	query CreateReportModalQuery {
		viewer {
			actualPersonId
			component(name: "create_report_modal")
			...CreateReportModal_viewer
		}
	}
`;

export default createFragmentContainer(CreateReportModal, {
	viewer: graphql`
		fragment CreateReportModal_viewer on Viewer {
			company {
				isUsingProjectAllocation
				isUsingSchedulingPlanMode
				isUsingMixedAllocation
				sageIntacctConnectionEnabled
				sageIntacctTimeRegsFromForecast
			}
		}
	`,
});
